<div class="shippn-become-a-host-background-color">
  <div class="shippn-become-a-host-background-test">
    <div class="shippn-homepage-container container shippn-become-a-host-background-image">
      <div class="row">
        <div style="margin-top: 15px;" class="col-lg-6 become-a-host-area-left-padding become-a-host-first-area-height">

          <div class="row">
            <div style="text-align: left;margin-top: 0;" class="col-md-6">
              <h3 style="font-weight: bold;font-size: 18px;">Become a Shippn Host</h3>
            </div>
            <div class="col-md-12" style="margin-top: 5px;">
              <p style="font-size: 14px; margin-bottom: 5px;">
                Join, Ship, Earn: It's that simple!
              </p>
              <ul style="font-size: 14px; padding-left: 15px; margin: 0;">
                <li>
                  Use your address to help others shop globally.
                </li>
                <li>
                  Get paid for each package you ship.
                </li>
              </ul>
            </div>

          </div>



          <form ngNativeValidate [formGroup]="form">
            <div class="row">
              <div style="margin-top: 15px; padding-right: 7.5px" class="col-6">
                <div id="input_container">

                  <input (keypress)="keyPressAlphabethic($event)" id="only-text" formControlName="firstName"
                    [ngClass]="{'shippn-border-red':form.get('firstName').touched && form.get('firstName').invalid}"
                    type="text" name="first-name" required minlength="2" class="form-control shippn-input bg-white"
                    placeholder="Name">
                  <i *ngIf="form.get('firstName').touched && form.get('firstName').invalid" id="input_img"
                    class="fas fa-times"></i>

                </div>
              </div>

              <div style="margin-top: 15px; padding-left: 7.5px;" class="col-6">

                <div id="input_container">
                  <input (keypress)="keyPressAlphabethic($event)" name="signupSurname" formControlName="lastName"
                    required minlength="2" type="text"
                    [ngClass]="{'shippn-border-red':form.get('lastName').touched && form.get('lastName').invalid}"
                    class="form-control shippn-input bg-white " placeholder="Last Name">
                  <i *ngIf="form.get('lastName').touched && form.get('lastName').invalid" id="input_img"
                    class="fas fa-times"></i>
                </div>



              </div>
            </div>

            <div class="row">
              <div style="margin-top: 15px;" class="col-md-6">
                <div class="input_container">
                  <input style="padding-right: 35px;" formControlName="email"
                    [ngClass]="{'shippn-border-red':form.get('email').touched && form.get('email').invalid}" required
                    type="email" class="form-control shippn-input bg-white " placeholder="Email">
                  <i style="right: 19px;" *ngIf="form.get('email').touched && form.get('email').invalid" id="input_img"
                    class="fas fa-times"></i>
                </div>

              </div>

              <div style="margin-top: 15px;" class="col-md-6">
                <div class="input_container">
                  <input formControlName="password"
                    [ngClass]="{'shippn-border-red':form.get('password').touched && form.get('password').invalid}"
                    name="signupPassword" required type="password" class="form-control shippn-input bg-white "
                    placeholder="Password">
                  <i style="right: 19px;" *ngIf="form.get('password').touched && form.get('password').invalid"
                    id="input_img" class="fas fa-times"></i>
                </div>

              </div>

              <div style="margin-top: 15px;" class="col-md-12 mb-3">
                <div class="select--wrapper bg-white b-rad-5">
                  <i class="fas fa-chevron-down"
                    style="position: absolute; right: 20px; top: 11px;float: right; color: #222222; border-radius: 32%; padding: 7px; font-size: 12px;"
                    aria-hidden="true"></i>
                  <select formControlName="country"
                    style="-webkit-appearance: none;-moz-appearance: none;appearance: none;width: 100%; border-radius: 5px;padding:10px 15px !important;height: 43px;"
                    class="form-select  shippn-input" class="form-control-sm" aria-label=".form-select-lg example">
                    <option *ngFor="let country of counrtyList;" value="{{country.code}}">
                      <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </option>
                  </select>
                </div>
              </div>
              <div style="margin-top: 5px;" class="col-md-12">
                <div style="display: inline-flex;" class="form-check">
                  <input formControlName="receiveCheckbox" style="width: 27px;height: 27px;margin-top: 0;"
                    class="form-check-input" type="checkbox" id="defaultCheck1">
                  <label style="margin-left: 15px;" class="form-check-label" for="defaultCheck1">
                    <p style="font-weight: 400;font-size: 13px;color: #000000a6;margin-bottom: 8px;">I Would like to
                      receive coupons, promotions, and updates via email or
                      phone from Shippn. By signing up, I
                      accept the <a style="color: #007bff;cursor: pointer;" data-toggle="modal"
                        data-target="#termsModal">terms & conditions</a> | <a style="color: #007bff;cursor: pointer;"
                        data-toggle="modal" data-target="#privacyModal">privacy policy</a></p>
                  </label>
                </div>
              </div>


              <div style="margin-top: 15px;" class="col-lg-12 col-md-12">
                <ngx-recaptcha2 #captchaElem [siteKey]="googleRecapthaSiteKey" [useGlobalDomain]="false"
                  formControlName="recaptcha">
                </ngx-recaptcha2>
                <span *ngIf="form.get('recaptcha').touched && form.get('recaptcha').invalid"
                  style="color: red;font-size: 14px;">This field is required.</span>
              </div>
              <div style="margin-top: 15px;" class="col-md-12">
                <button *ngIf="!passingSignupData" (click)="signUp()"
                  style="background-color: #ff6c36;padding: 12px 12px;border: #ff6c36;color: white;width: 100%;font-weight: 600;"
                  type="submit" class="btn">SIGN UP</button>

                <a *ngIf="passingSignupData"
                  style="background-color: #ff6c36;padding: 22px 12px;border: #ff6c36;color: white;width: 100%;font-weight: 600;"
                  class="btn btn-loading-white"></a>
              </div>

              <div style="margin-top: 15px;" class="col-md-6">
                <a (click)="loginWithFacebook()"
                  style="font-size: 13px;padding: 15px;display: flex;align-items: center;justify-content: center;"
                  class="btn btn-block btn-facebook"><i style="font-size: 21px;"
                    class="glyphicon glyphicon-facebook"></i> Connect with Facebook</a>
              </div>

              <div style="margin-top: 15px;margin-bottom: 40px;" class="col-md-6">
                <a (click)="loginWithGoogle()"
                  style="font-size: 13px;padding: 15px;display: flex;align-items: center;justify-content: center;"
                  class="btn btn-block btn-google"><i style="font-size: 21px;" class="glyphicon glyphicon-google"></i>
                  Connect with Google</a>
              </div>

            </div>

          </form>
        </div>
        <div style="margin-top: 15px;text-align: center;" class="col-lg-6 become-a-host-expl-area">
          <h6 style="color: white;font-size: 22px; margin-top:0px; margin-bottom: 20px;">How to become a Shippn host?
          </h6>
          <div class="shippn-become-a-host-info-boxes-wrapper">
            <div class="shippn-become-a-host-info-boxes">
              <div class="info-image-holder">
                <img src="../../../assets/img/become-a-host-slider-image.png"
                  alt="Shippn Become a host first slider image">
              </div>
              <div class="info-content">
                <h6 style="color: white;font-size: 28px;">FREE SIGN-UP</h6>
                <hr style="border-color: white;margin-top: 10px;margin-bottom: 10px;">
                <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
                  Fill in the form to join our host community
                </p>
              </div>
            </div>
            <div class="shippn-become-a-host-info-boxes">
              <div class="info-image-holder">
                <img src="../../../assets/img/become-a-host-slider-image-2.png"
                  alt="Shippn become a host slider second image">
              </div>
              <div class="info-content">
                <h6 style="color: white;font-size: 28px;">ID VERIFICATION</h6>
                <hr style="border-color: white;margin-top: 10px;margin-bottom: 10px;">
                <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
                  Provide requested ID documents and complete onboarding
                </p>
              </div>
            </div>
            <div class="shippn-become-a-host-info-boxes">
              <div class="info-image-holder">
                <img src="../../../assets/img/become-a-host-slider-image-3.png"
                  alt="Shippn become a host slider third image">
              </div>
              <div class="info-content">
                <h6 style="color: white;font-size: 28px;">GET YOUR PACKAGES</h6>
                <hr style="border-color: white;margin-top: 10px;margin-bottom: 10px;">
                <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
                  Receive packages to your address and earn money 
                </p>
              </div>
            </div>
            <div class="shippn-become-a-host-info-boxes">
              <div class="info-image-holder">
                <img src="/assets/img/become-a-host-maximize-earn.webp" alt="Shippn become a host slider third image">
              </div>
              <div class="info-content">
                <h6 style="color: white;font-size: 28px;">EARN MORE</h6>
                <hr style="border-color: white;margin-top: 10px;margin-bottom: 10px;">
                <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
                  Maximize your income via additional services
                </p>
                
              </div>
            </div>

          </div>
          <a href="howitworks-for-hosts" class="learn-more-button" target="_blank"
                  style="color: white;cursor: pointer;margin-top: 30px;">Learn More</a>
        </div>
      </div>
    </div>
  </div>



  <div style="background-color: #ebebeb;">
    <div class="shippn-homepage-container container">
      <div style="padding-top: 20px;padding-bottom: 80px;" class="row">
        <div style="margin-top: 20px;" class="col-lg-4">
          <div class="become-a-host-second-area-border" style="padding: 15px;">
            <h6 style="color: #2c2c2c;font-size: 16px;">Why become a Shippn Host?
            </h6>
            <p style="color: #2c2c2c;font-size: 16px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
              As a host, you'll play a crucial role in helping shoppers worldwide access products from your country with
              ease. Earn money effortlessly by simply receiving and forwarding packages from the comfort of your own
              home
            </p>
          </div>
        </div>
        <div style="margin-top: 20px;" class="col-lg-4">
          <div class="become-a-host-second-area-border" style="padding: 15px;">
            <h6 style="color: #2c2c2c;font-size: 16px;">Empower Your Schedule: Work from Home as a Shippn Host
            </h6>
            <p style="color: #2c2c2c;font-size: 16px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
              Take control of your schedule and workload as a Shippn host. Work from home on your terms and get paid for
              it. Enjoy the flexibility and freedom to earn money effortlessly while providing a valuable service.'
            </p>
          </div>
        </div>
        <div style="margin-top: 20px;" class="col-lg-4">
          <div style="padding: 15px;">
            <h6 style="color: #2c2c2c;font-size: 16px;">Guiding You Every Step of the Way
            </h6>
            <p style="color: #2c2c2c;font-size: 16px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
              Our dedicated customer service team is here to support you through every stage of the process. Rest
              assured, our system complies with all international shipping laws, ensuring your protection from any
              complications. Remember, you're not just a host—you're a valued member of the Shippn Team.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="termsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Terms & Conditions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <terms-content [textColorClass]="'black-text'" [maxHeight]="500"></terms-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


<button style="width:0; height:0; display: none;" id="socialUpdateModalTriggerBtn" data-toggle="modal"
  data-target="#socialUpdateModal"></button>
<!-- Social Update Modal -->
<div class="modal fade" id="socialUpdateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 600px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div style="background: #222222;" class="modal-header">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">Update Profile
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>

      <form ngNativeValidate [formGroup]="socialUpdateForm">
        <div style="padding-left: 50px;padding-right: 50px;" class="modal-body">

          <div class="row">
            <div class="col-md-12">
              <p style="margin-bottom: 0px;font-size: 16px;font-weight: 300;text-align: left;">
                Enter your email address
              </p>
            </div>
          </div>


          <div class="row">
            <div style="margin-top: 10px;" class="col-12 col-lg-12">
              <p style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 5px;">
                Email</p>
              <input type="email" formControlName="email"
                [ngClass]="{'shippn-border-red':socialUpdateForm.get('email').touched && socialUpdateForm.get('email').invalid}"
                placeholder="Email" class="form-control form-control-sm shippn-input">
            </div>
          </div>

          <div class="row">
            <div style="margin-top: 10px;" class="col-md-12">
              <button style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;"
                (click)="updateSocialLoginProfile()" class="btn shippn-from-to-area-go-btn">Save</button>
            </div>
          </div>

        </div>


      </form>

    </div>
  </div>
</div>


<!-- Facebook Authorization Waiting Modal-->
<button style="width:0; height:0; display: none;" id="facebookLoginStatusModalBtn" data-toggle="modal"
  data-target="#facebookLoginStatusModal"></button>
<!-- Modal -->
<div class="modal fade" id="facebookLoginStatusModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div style="max-width: 600px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background: #222222;">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
          Connect with Facebook </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div style="text-align: left;max-height: 500px;overflow-y: auto;" class="col-md-12">
          <div style="color: #0f0f0f;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;"
            *ngIf="!facebookLoginErrorMessage">
            <p style="text-align:center;">
              Waiting for Facebook authorization.
            </p>
            <div
              style="background-image: url(../../assets/img/loading-black.gif);background-repeat: no-repeat;background-position: center;height: 35px;width: 100%;">
            </div>
          </div>
          <p *ngIf="facebookLoginErrorMessage"
            style="color: #0f0f0f; font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
            {{facebookLoginErrorMessage}}
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;" data-dismiss="modal"
          class="btn shippn-from-to-area-go-btn pull-right" id="facebookLoginCloseModalBtn">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- Privacy Modal-->
<div class="modal fade" id="privacyModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Privacy Policy</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <privacy-content [maxHeight]="500" [textColorClass]="'black-text'"></privacy-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Privacy Modal-->